<template>
  <div class="muteBtn" @click="toggleMute()">
    <template v-if="muted">
      <svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1"
           xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink">
        <circle id="Oval-3" fill-opacity="0.5" fill="#000000" cx="17" cy="17" r="17"></circle>
        <path
          d="M21.5,17 C21.5,15.23 20.48,13.71 19,12.97 L19,15.18 L21.45,17.63 C21.48,17.43 21.5,17.22 21.5,17 Z M24,17 C24,17.94 23.8,18.82 23.46,19.64 L24.97,21.15 C25.63,19.91 26,18.5 26,17 C26,12.72 23.01,9.14 19,8.23 L19,10.29 C21.89,11.15 24,13.83 24,17 Z M9.27,8 L8,9.27 L12.73,14 L8,14 L8,20 L12,20 L17,25 L17,18.27 L21.25,22.52 C20.58,23.04 19.83,23.45 19,23.7 L19,25.76 C20.38,25.45 21.63,24.81 22.69,23.95 L24.73,26 L26,24.73 L17,15.73 L9.27,8 Z M17,9 L14.91,11.09 L17,13.18 L17,9 Z"
          id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
      </svg>
    </template>
    <template v-else>
      <svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1"
           xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           xml:space="preserve" xmlns:serif="http://www.serif.com/"
           style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
        <g id="volume_off">
            <circle id="Oval-3" cx="17" cy="17" r="17" style="fill-opacity:0.498039;"/>
          <path id="Shape" d="M5,5L29,5L29,29L5,29L5,5Z" style="fill:none;"/>
          <path id="Shape1" serif:id="Shape"
                d="M17,9L12.73,14L8,14L8,20L12,20L17,25L17,9ZM17,9L12.73,14L17,9Z"
                style="fill:white;fill-rule:nonzero;"/>
          <path
            d="M18.987,8.155C23.004,9.092 26,12.699 26,17C26,21.301 23.004,24.908 18.987,25.845L18.987,23.667C21.83,22.785 23.897,20.132 23.897,17C23.897,13.868 21.83,11.215 18.987,10.333L18.987,8.155Z"
            style="fill:rgb(235,235,235);"/>
          <path
            d="M18.987,12.962C20.475,13.696 21.5,15.229 21.5,17C21.5,18.771 20.475,20.304 18.987,21.038L18.987,12.962Z"
            style="fill:rgb(235,235,235);"/>
        </g>
    </svg>
    </template>
  </div>
</template>
<script>

export default {
  name: 'Mute',
  props: [
    'muted',
    'name',
  ],
  methods: {
    toggleMute() {
      this.$emit('toggleMute', this.name);
    },
  },
};
</script>
